import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import qc from 'keys/queryClient'
import { statuses } from 'keys'
import { getAssessmentCostsSummaryFetch } from 'store/middlewares/assessment.crud'
import { categoriesWithIcons } from 'keys/categories'

// רק מבדקים שסימון המילים בהם הסתיים בפועל נושאים משך סימון משמעותי לחישוב עלות
const COMPLETED_MARKING_STATUS_FILTERS = {
    status: [statuses.inProgress],
    sub_status: [statuses.wordsComplete],
    exclude_sub_status: [],
}

const useAssessmentCostsData = ({ assessmentFilters }) => {
    const { headerFilters } = useSelector(state => state.header)

    const query = useQuery({
        queryKey: [qc.assessmentCosts, headerFilters, assessmentFilters],
        queryFn: async ({ signal }) => {
            // הממוצעים/הסכומים מחושבים בשרת (reading_assessment_cost_bl.get_assessment_costs_report) -
            // מתקבלות כמה שורות סיכום בלבד, לא כל המבדקים הגולמיים
            const { data } = await getAssessmentCostsSummaryFetch({
                headerFilters,
                assessmentFilters,
                statusFilters: COMPLETED_MARKING_STATUS_FILTERS,
                signal,
            })
            return data
        },
        staleTime: 5 * 60 * 1000,
    })

    const categories = (query.data?.categories || []).map(category => ({
        categoryName: category.category_name,
        label: categoriesWithIcons[category.category_name]?.label || category.category_label,
        icon: categoriesWithIcons[category.category_name]?.icon,
        count: category.count,
        avgDurationMinutes: category.avg_duration_minutes,
        avgCost: category.avg_cost,
        totalCost: category.total_cost,
        totalDurationMinutes: category.total_duration_minutes,
    }))

    return {
        categories,
        monthOptions: query.data?.month_options || [],
        totalCount: query.data?.total_count || 0,
        totalAvgCost: query.data?.total_avg_cost || 0,
        totalAvgDurationMinutes: query.data?.total_avg_duration_minutes || 0,
        totalCost: query.data?.total_cost || 0,
        totalDurationMinutes: query.data?.total_duration_minutes || 0,
        isLoading: query.isFetching,
        refetch: query.refetch,
    }
}

export default useAssessmentCostsData
